<template>
  <app-timeline>
    <app-timeline-item
        v-for="binnacleItem in binnacles"
        :key="binnacleItem.bitacoraId"
        icon="InfoIcon"
        :variant="getSeverity(binnacleItem.severidad)"
    >
      <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
        <h6>{{ binnacleItem.usuarioNombre }}</h6>
        <small class="text-muted"> {{ binnacleItem.fecha | dateCompleteFormat }} </small>
      </div>
      <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
        <p>{{ binnacleItem.mensaje }}</p>
        <div class="mb-1 mb-sm-0">
          <div>
            <b-avatar
                v-if="binnacleItem.tipoVista == -1 || binnacleItem.tipoVista == 0"
                v-b-tooltip.hover
                title="Registro Visible solo para Admin"
                text="O"
                class="mr-50"
                size="24"
                icon="eye-slash-fill"
                variant="secondary"
            />
            <b-avatar
                v-has-permission="'FEB99'"
                v-b-tooltip.hover
                title="Copiar Seguimiento"
                text="S"
                class="mr-50 add-code"
                size="24"
                icon="bug"
                variant="success"
                @click.native="copyToClipboard(binnacleItem.seguimientoId)"
            />
          </div>
        </div>
      </div>
    </app-timeline-item>
    <app-timeline-item v-if="isLoading">
      <div class="d-flex flex-column justify-content-center align-items-center">
        <b-spinner
            class="mr-2"
            variant="primary"
        />
        <small>Cargando...</small>
      </div>
    </app-timeline-item>
    <app-timeline-item
        v-if="!isLoading && actualPage < totalPages"
        v-on:click.once="loadMorePages"
    >
      <div class="d-flex flex-column justify-content-center align-items-center">
        <small>Cargar mas registros</small>
      </div>
    </app-timeline-item>
  </app-timeline>
</template>
<script>

import { getBinnacleList } from '@/febos/servicios/api/aduanas/binacles';
import AppTimeline from '@core/components/app-timeline/AppTimeline';
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem';
import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';

export default {
  name: 'BinnacleList',
  mixins: [CopyToClipboard],
  components: {
    AppTimeline,
    AppTimelineItem
  },
  props: ['title'],
  data() {
    return {
      actualId: undefined,
      isLoading: true,
      actualPage: 1,
      totalPages: 1,
      itemsPerPage: 20,
      binnacles: []
    };
  },
  computed: {},
  methods: {
    list(id) {
      this.actualId = id;
      this.binnacles = [];
      this.actualPage = 1;
      this.totalPages = 1;
      this.listBinnaclePage();
    },
    getSeverity(severity) {
      switch (severity) {
        case 1:
          return 'info';
        case 2:
          return 'warning';
        case 3:
          return 'danger';
        default:
          return 'secondary';
      }
    },
    async listBinnaclePage() {
      this.isLoading = true;
      const payload = {
        id: this.actualId,
        page: this.actualPage,
        items: this.itemsPerPage
      };
      try {
        const { data: { bitacora, totalPaginas } } = await getBinnacleList(payload);
        this.binnacles = this.binnacles.concat(bitacora);
        this.totalPages = totalPaginas;
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async loadMorePages() {
      this.actualPage += 1;
      await this.listBinnaclePage();
    }
  }
};
</script>
